import type { Sport } from '@sharpr/types';

// NBA Team logo mappings
const NBA_TEAM_LOGOS: Record<string, string> = {
  // Atlantic Division
  'BOS': '/logos/teams/nba/bos.png',
  'BKN': '/logos/teams/nba/bkn.png',
  'NYK': '/logos/teams/nba/nyk.png',
  'PHI': '/logos/teams/nba/phi.png',
  'TOR': '/logos/teams/nba/tor.png',
  // Central Division
  'CHI': '/logos/teams/nba/chi.png',
  'CLE': '/logos/teams/nba/cle.png',
  'DET': '/logos/teams/nba/det.png',
  'IND': '/logos/teams/nba/ind.png',
  'MIL': '/logos/teams/nba/mil.png',
  // Southeast Division
  'ATL': '/logos/teams/nba/atl.png',
  'CHA': '/logos/teams/nba/cha.png',
  'MIA': '/logos/teams/nba/mia.png',
  'ORL': '/logos/teams/nba/orl.png',
  'WAS': '/logos/teams/nba/was.png',
  // Northwest Division
  'DEN': '/logos/teams/nba/den.png',
  'MIN': '/logos/teams/nba/min.png',
  'OKC': '/logos/teams/nba/okc.png',
  'POR': '/logos/teams/nba/por.png',
  'UTA': '/logos/teams/nba/uta.png',
  // Pacific Division
  'GSW': '/logos/teams/nba/gsw.png',
  'LAC': '/logos/teams/nba/lac.png',
  'LAL': '/logos/teams/nba/lal.png',
  'PHX': '/logos/teams/nba/phx.png',
  'SAC': '/logos/teams/nba/sac.png',
  // Southwest Division
  'DAL': '/logos/teams/nba/dal.png',
  'HOU': '/logos/teams/nba/hou.png',
  'MEM': '/logos/teams/nba/mem.png',
  'NOP': '/logos/teams/nba/nop.png',
  'SAS': '/logos/teams/nba/sas.png',
};

// MLB Team logo mappings
const MLB_TEAM_LOGOS: Record<string, string> = {
  // AL East
  'BAL': '/logos/teams/mlb/bal.png',
  'BOS': '/logos/teams/mlb/bos.png',
  'NYY': '/logos/teams/mlb/nyy.png',
  'TB': '/logos/teams/mlb/tb.png',
  'TOR': '/logos/teams/mlb/tor.png',
  // AL Central
  'CHC': '/logos/teams/mlb/chc.png',
  'CWS': '/logos/teams/mlb/cws.png',
  'CLE': '/logos/teams/mlb/cle.png',
  'DET': '/logos/teams/mlb/det.png',
  'KC': '/logos/teams/mlb/kc.png',
  'MIN': '/logos/teams/mlb/min.png',
  // AL West
  'HOU': '/logos/teams/mlb/hou.png',
  'LAA': '/logos/teams/mlb/laa.png',
  'ATH': '/logos/teams/mlb/ath.png',
  'SEA': '/logos/teams/mlb/sea.png',
  'TEX': '/logos/teams/mlb/tex.png',
  // NL East
  'ATL': '/logos/teams/mlb/atl.png',
  'MIA': '/logos/teams/mlb/mia.png',
  'NYM': '/logos/teams/mlb/nym.png',
  'PHI': '/logos/teams/mlb/phi.png',
  'WSH': '/logos/teams/mlb/wsh.png',
  // NL Central
  'CHI': '/logos/teams/mlb/chc.png', // Cubs (alias)
  'CIN': '/logos/teams/mlb/cin.png',
  'MIL': '/logos/teams/mlb/mil.png',
  'PIT': '/logos/teams/mlb/pit.png',
  'STL': '/logos/teams/mlb/stl.png',
  // NL West
  'AZ': '/logos/teams/mlb/ari.png',
  'COL': '/logos/teams/mlb/col.png',
  'LAD': '/logos/teams/mlb/lad.png',
  'SD': '/logos/teams/mlb/sd.png',
  'SF': '/logos/teams/mlb/sf.png',
};

// Teams with separate dark mode logos
const DARK_MODE_LOGOS: Record<string, string> = {
  'NYY': '/logos/teams/mlb/nyy-white.png',
  'SD': '/logos/teams/mlb/sd-gold.png',
};

/**
 * Get team logo path based on sport
 */
export function getTeamLogo(team: string, sport: Sport = 'nba'): string | undefined {
  const logoMap = sport === 'mlb' ? MLB_TEAM_LOGOS : NBA_TEAM_LOGOS;
  return logoMap[team];
}

/**
 * Get dark mode logo override, if one exists
 */
export function getDarkModeLogo(team: string): string | undefined {
  return DARK_MODE_LOGOS[team];
}